<template>
  <div class="body-wrap" :class="{mobileScreen: isMobileScreen}">
    <MainHeader v-if="loaded && !isLandingPage" @openPopup="openPopup" :canIRerenderComponent="canIRerenderHeader" />
  
    <router-view @openPopup="openPopup"
      @rerenderHeader="rerenderHeader"
      @langingPage="value => isLandingPage = value"
      @pageUpdate="value => loaded = value"></router-view>

    <MainFooter v-if="loaded" />

    <PopupWrapper v-if="loaded || isLandingPage" :popupName="popupName" 
      :data="popupData"
      :popupOpen="popupOpen" 
      @openPopup="openPopupInPopup" 
      @closePopup="closePopup"
      @rerenderHeader="rerenderHeader" />

  </div>
</template>

<script>
import MainHeader from "@/components/Header/MainHeader";
import MainFooter from "@/components/Footer/MainFooter";
import PopupWrapper from "@/components/Popups/PopupWrapper";

import {auth} from '@/mixins/auth'
import {session} from '@/mixins/session'
import { mapState } from 'vuex';

export default {
  name: "App",

  components: {
    MainHeader,
    MainFooter,
    PopupWrapper
  }, 

  mixins: [
    auth,
    session
  ],

  data() {
    return {
      popupName: '',
      popupOpen: false,
      canIRerenderHeader: false,
      popupData: {},

      loaded: false,
      isLandingPage: false
    }
  },
  
  computed: {
    ...mapState({
      isMobileScreen: state => state.mobileScreen,
      // authStateChecked: state => state.auth.authStateChecked
    })
  },

  methods: {
    pageLoaded() {
      this.loaded = true;
    },
    
    closePopup() {
      this.popupName = ''
      this.popupOpen = false
    },

    openPopup(data) {
      this.popupOpen = false
      this.popupOpen = true

      this.popupName = data.name;
      this.popupData = {...data}
    },

    openPopupInPopup(data) {
      this.popupName = data.name;
      this.popupData = {...data}
    },

    rerenderHeader() {
      this.canIRerenderHeader = true;
      this.canIRerenderHeader = false;
    },

    updateReferral() {
      let params = (new URL(document.location)).searchParams;

      if (params.has("ref")) {
        localStorage.setItem('referral', params.get("ref"))
      }
    }
  },

  created() {
    // this.tokenValidate()
  },

  mounted() {
    this.updateReferral() 
  },
};
</script>

<style lang="scss">
#app {
  height: 100%;
}

button {
  background: transparent;
  border: 0;
  font-size: 1em;
  cursor: pointer;
}

img {
  font-size: 1em;
}

.error-item{
    position: absolute;
    left: 0;
    bottom: em(-28);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    opacity: 0;
    pointer-events: none;
    user-select: none;
    img{
        width: em(22);
        pointer-events: none;
        user-select: none;
    }
    span{
        top: em(2,14);
        position: relative;
        display: inline-block;
        margin-left: em(5);
        line-height: 1;
        font-size: em(14);
        color: #c6bba7;
        font-family: 'Visby CF Demi';
        font-weight: 600;
    }
    &.active{
        opacity: 1;
        pointer-events: unset;
        user-select: unset;
    }
}

.main-page-2__item_text_3 {
  b.color {
    color: #01FFC2;
  }
}

.mobileScreen {
  @media (max-width: 1024px) {
    .main-page-1__text {
      & span br {
        display: block !important
      }
    }
  }
}
</style>
